import { Toast as _Toast, ToastProps as _ToastProps } from "reactstrap";

export const Toast = _Toast;
export type ToastProps = _ToastProps;
